module.exports = __webpack_public_path__ + "img/beggars_beggarsto.gm.8cfca91.png";